/* ═══════════════════════════════════════════════════════════════
   TG BRAND MIGRATION — Header JS
   Scroll-state toggle + mega menu hover
   Nav and sub-nav are now Liquid — no DOM injection needed
   ═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var header = document.querySelector('.section-header');
  if (!header) return;

  /* ── Scroll detection ─────────────────────────────────────── */
  var announceH = 0;

  function getAnnounceH() {
    var bar = document.querySelector('.section-announcement-bar');
    return bar ? bar.offsetHeight : 0;
  }

  function onScroll() {
    var y = window.scrollY || window.pageYOffset || 0;
    header.classList.toggle('tg-scrolled', y > 40);
    if (announceH > 0) {
      header.style.top = y >= announceH ? '0px' : (announceH - y) + 'px';
    } else {
      header.style.top = '';
    }
  }

  function initScroll() {
    announceH = getAnnounceH();
    if (announceH > 0) header.style.top = announceH + 'px';
    onScroll();
  }

  if (!header.dataset.tgScrollBound) {
    window.addEventListener('scroll', onScroll, { passive: true });
    header.dataset.tgScrollBound = '1';
  }
  /* Run as early as possible to prevent flash of header above announcement bar,
     then re-run on load in case marquee/dynamic content shifts bar height */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScroll);
    window.addEventListener('load', initScroll);
  } else {
    initScroll();
    if (document.readyState !== 'complete') {
      window.addEventListener('load', initScroll);
    }
  }

  /* ResizeObserver: re-measure if announcement bar height changes after init
     (covers marquee/ticker content that settles after DOMContentLoaded) */
  function watchAnnounceBar() {
    var bar = document.querySelector('.section-announcement-bar');
    if (!bar || !window.ResizeObserver) return;
    new ResizeObserver(function () {
      announceH = getAnnounceH();
      onScroll();
    }).observe(bar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchAnnounceBar);
  } else {
    watchAnnounceBar();
  }

  /* ── Mega menu hover ──────────────────────────────────────── */
  var closeTimer = null;

  function openPanel(key) {
    clearTimeout(closeTimer);
    header.querySelectorAll('.tg-mega-panel').forEach(function (p) {
      var isTarget = p.dataset.panelKey === key;
      p.classList.toggle('is-open', isTarget);
      p.setAttribute('aria-hidden', isTarget ? 'false' : 'true');
    });
    header.querySelectorAll('.tg-nav-item .header__nav-link').forEach(function (a) {
      a.classList.toggle('tg-active', a.closest('.tg-nav-item').dataset.navKey === key);
    });
  }

  function scheduleClose() {
    closeTimer = setTimeout(function () {
      header.querySelectorAll('.tg-mega-panel').forEach(function (p) {
        p.classList.remove('is-open');
        p.setAttribute('aria-hidden', 'true');
      });
      header.querySelectorAll('.header__nav-link.tg-active').forEach(function (a) {
        a.classList.remove('tg-active');
      });
    }, 200);
  }

  function bindNavItems() {
    header.querySelectorAll('.tg-nav-item[data-has-dropdown="true"]').forEach(function (item) {
      var key = item.dataset.navKey;
      item.addEventListener('mouseenter', function () { openPanel(key); });
      item.addEventListener('mouseleave', scheduleClose);
      var panel = header.querySelector('.tg-mega-panel[data-panel-key="' + key + '"]');
      if (panel) {
        panel.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
        panel.addEventListener('mouseleave', scheduleClose);
      }
    });
  }

  /* ── Sub-nav dropdowns ────────────────────────────────────── */
  var subCloseTimer = null;

  function openSubPanel(key) {
    clearTimeout(subCloseTimer);
    header.querySelectorAll('.tg-sub-dropdown').forEach(function (p) {
      var isTarget = p.dataset.subPanel === key;
      p.classList.toggle('is-open', isTarget);
      p.setAttribute('aria-hidden', isTarget ? 'false' : 'true');
    });
  }

  function scheduleSubClose() {
    subCloseTimer = setTimeout(function () {
      header.querySelectorAll('.tg-sub-dropdown').forEach(function (p) {
        p.classList.remove('is-open');
        p.setAttribute('aria-hidden', 'true');
      });
    }, 200);
  }

  function bindSubNavItems() {
    /* The dropdown is a child of the <li>, so mouseleave on the <li>
       only fires when the cursor exits both the link AND the dropdown. */
    header.querySelectorAll('.tg-sub-nav__item.has-dropdown').forEach(function (item) {
      var key = item.dataset.subKey;
      item.addEventListener('mouseenter', function () { openSubPanel(key); });
      item.addEventListener('mouseleave', scheduleSubClose);
    });
  }

  /* ── Sub-nav mega panels ──────────────────────────────────── */
  /* Items rendered as .has-mega (children with their own links) open a
     full-width .tg-sub-mega-panel on hover (after a short hover-intent
     delay) or keyboard focus, close on mouseleave, focus leaving the item,
     or Escape, and keep aria-expanded on the top-level link in sync.
     The header itself does not change state, as for the plain dropdowns.
     Plain .has-dropdown items are untouched. */
  var MEGA_OPEN_DELAY = 120;
  var MEGA_CLOSE_DELAY = 200;
  var megaOpenTimer = null;
  var megaCloseTimer = null;

  function setMega(item, open) {
    var link = item.querySelector('.tg-sub-nav__link');
    var panel = item.querySelector('.tg-sub-mega-panel');
    item.classList.toggle('is-open', open);
    if (panel) panel.classList.toggle('is-open', open);
    if (link) link.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function closeAllMega(except) {
    header.querySelectorAll('.tg-sub-nav__item.has-mega').forEach(function (item) {
      if (item !== except) setMega(item, false);
    });
  }

  function openMega(item) {
    clearTimeout(megaOpenTimer);
    clearTimeout(megaCloseTimer);
    closeAllMega(item);
    setMega(item, true);
  }

  function closeMega(item) {
    clearTimeout(megaOpenTimer);
    clearTimeout(megaCloseTimer);
    setMega(item, false);
  }

  function scheduleMegaOpen(item) {
    clearTimeout(megaCloseTimer);
    if (item.classList.contains('is-open')) return;
    clearTimeout(megaOpenTimer);
    megaOpenTimer = setTimeout(function () { openMega(item); }, MEGA_OPEN_DELAY);
  }

  function scheduleMegaClose(item) {
    clearTimeout(megaOpenTimer);
    clearTimeout(megaCloseTimer);
    megaCloseTimer = setTimeout(function () { closeMega(item); }, MEGA_CLOSE_DELAY);
  }

  function bindSubMegaItems() {
    var items = header.querySelectorAll('.tg-sub-nav__item.has-mega');
    if (!items.length) return;

    items.forEach(function (item) {
      if (item.dataset.tgMegaBound) return;
      item.dataset.tgMegaBound = '1';
      var link = item.querySelector('.tg-sub-nav__link');

      item.addEventListener('mouseenter', function () { scheduleMegaOpen(item); });
      item.addEventListener('mouseleave', function () { scheduleMegaClose(item); });

      item.addEventListener('focusin', function () {
        /* Skip the reopen when focus is returned to the link by Escape */
        if (item.dataset.tgMegaSuppress) {
          delete item.dataset.tgMegaSuppress;
          return;
        }
        openMega(item);
      });
      item.addEventListener('focusout', function (e) {
        if (!e.relatedTarget || !item.contains(e.relatedTarget)) closeMega(item);
      });

      item.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' || e.key === 'Esc') {
          if (!item.classList.contains('is-open')) return;
          e.preventDefault();
          closeMega(item);
          if (link && document.activeElement !== link) {
            item.dataset.tgMegaSuppress = '1';
            link.focus();
          }
        } else if (e.key === 'ArrowDown' && e.target === link) {
          var first = item.querySelector('.tg-sub-mega-panel a');
          if (!first) return;
          e.preventDefault();
          openMega(item);
          first.focus();
        }
      });
    });

    if (!header.dataset.tgMegaEscBound) {
      header.dataset.tgMegaEscBound = '1';
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' || e.key === 'Esc') {
          clearTimeout(megaOpenTimer);
          clearTimeout(megaCloseTimer);
          closeAllMega(null);
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bindNavItems();
      bindSubNavItems();
      bindSubMegaItems();
    });
  } else {
    bindNavItems();
    bindSubNavItems();
    bindSubMegaItems();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.classList.contains('section-header')) {
      bindNavItems();
      bindSubNavItems();
      bindSubMegaItems();
    }
  });
})();
